import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import ProductForm from "../components/ProductForm";

export function NewProduct() {
  return (
    <div style={{background:"#fafafa",minHeight:"calc(100vh - 68px)"}}>
      <ProductForm />
    </div>
  );
}

export function EditProduct() {
  const { id } = useParams();
  const { products, currentUser } = useApp();
  const product = products.find(p => p.id === id);
  if (!product) return <Navigate to="/my-posts" replace />;
  if (product.sellerId !== currentUser?.id) return <Navigate to="/" replace />;
  return (
    <div style={{background:"#fafafa",minHeight:"calc(100vh - 68px)"}}>
      <ProductForm existing={product} />
    </div>
  );
}
